
import { Component, Vue } from 'vue-property-decorator';
import { OAClientModel } from '@/models/OAClient';

@Component({
  components: {
  },
})
export default class OAClientNewPage extends Vue {
  public oaClient: OAClientModel = new OAClientModel();
  public messageError: string = '';
  public isError: boolean = false;
  public showSecretDialog: boolean = false;
  public copyIcon: { [key: string]: string } = {
    clientId: 'mdi-content-copy',
    clientSecret: 'mdi-content-copy',
  };

  public async createClient() {
    try {
      await this.oaClient.save();
      this.isError = false;
      this.messageError = '';
      this.showSecretDialog = true;
    } catch (e: any) {
      this.isError = true;
      this.messageError = e.message;
    }
  }

  public closeDialog() {
    this.showSecretDialog = false;
    this.$router.push('/oa_clients');
  }

  public copyToClipboard(text: string, key: string) {
    navigator.clipboard.writeText(text).then(() => {
      this.copyIcon[key] = 'mdi-check';
      setTimeout(() => {
        this.copyIcon[key] = 'mdi-content-copy';
      }, 2000);
    });
  }

  public downloadAsJson() {
    const credentials = {
      clientId: this.oaClient.clientId,
      clientSecret: this.oaClient.clientSecret,
    };
    const dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(credentials, null, 2));
    const downloadAnchorNode = document.createElement('a');
    downloadAnchorNode.setAttribute("href", dataStr);
    downloadAnchorNode.setAttribute("download", "oauth-client-credentials.json");
    document.body.appendChild(downloadAnchorNode); // required for firefox
    downloadAnchorNode.click();
    downloadAnchorNode.remove();
  }
}
